<template>
<!-- Navigation -->
<nav class="navbar navbar-expand-lg navbar-light static-top">
    <div class="container">
        <!-- <a class="navbar-brand" href="#" @click="this.$parent.changeToStart"><img src="./../assets/images/hansedomizil.svg" style="height: 80px;" alt=""></a> -->
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarResponsive">
            <ul class="navbar-nav ml-auto">
                <li class="nav-item active">
                    <a class="nav-link" @click="this.$parent.changeToStart">Startseite</a>
                </li>
                <li class="nav-item">
<!--                    <a class="nav-link" @click="this.$parent.changeToImmoScout">Angebote</a> -->
                    <a class="nav-link" @click="this.$parent.changeToStart" target="_blank" href="https://www.immobilienscout24.de/anbieter/hanse-domizil-gmbh/a309ab422db89e75ebd8d">Angebote</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" @click="this.$parent.changeToOffice">Unsere Büros</a>
                </li>
<!--                <li class="nav-item">
                    <a class="nav-link" @click="this.$parent.changeToContact">Kontakt</a>
                </li> -->
                <li class="nav-item">
                    <a class="nav-link" @click="this.$parent.changeToImpressum">Impressum</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" @click="this.$parent.changeToDatenschutz">Datenschutz</a>
                </li>
            </ul>
        </div>
    </div>
</nav>
</template>

<script>
export default {

}
</script>

<style scoped>
a {
    cursor: pointer;
}
ul.navbar-nav a:hover { background-color: rgb(6, 30, 238) !important; color: #fff !important; }
</style>
